var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Snackbar from '@mui/material/Snackbar';
import IconButton from '@mui/material/IconButton';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import TaskAltRoundedIcon from '@mui/icons-material/TaskAltRounded';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
import { useTranslation } from 'react-i18next';
import { useSnackbarStore } from '../../../application/stores/snackBar.store';
var SnackbarFeedback = function () {
    var t = useTranslation().t;
    var _a = useSnackbarStore(), open = _a.open, type = _a.type, message = _a.message, autoHideDuration = _a.autoHideDuration, closeSnackbar = _a.closeSnackbar, resetSnackbar = _a.resetSnackbar;
    var handleClose = function () { return closeSnackbar(); };
    return (_jsx(Snackbar, __assign({ className: "snackbar-feedback ".concat(type), open: open, autoHideDuration: autoHideDuration, onClose: handleClose, TransitionProps: {
            onExited: resetSnackbar, // ✅ Se ejecuta cuando termina el fade-out
        }, anchorOrigin: { vertical: 'bottom', horizontal: 'center' } }, { children: _jsxs("div", __assign({ className: "snackbar-feedback_wrapper" }, { children: [type === 'error' ? (_jsx(ErrorOutlineOutlinedIcon, {})) : type === 'info' ? (_jsx(InfoOutlinedIcon, {})) : type === 'warning' ? (_jsx(WarningAmberRoundedIcon, {})) : (_jsx(TaskAltRoundedIcon, {})), _jsxs("div", { children: [_jsx("p", __assign({ className: "title" }, { children: type === 'error'
                                ? t('common.snackbar.errorTitle')
                                : type === 'info'
                                    ? t('common.snackbar.infoTitle')
                                    : type === 'warning'
                                        ? t('common.snackbar.warningTitle')
                                        : t('common.snackbar.successTitle') })), _jsx("p", __assign({ className: "mt-1" }, { children: message }))] }), _jsx(IconButton, __assign({ "aria-label": t('common.btn.close'), onClick: handleClose }, { children: _jsx(CloseRoundedIcon, {}) }))] })) })));
};
export default SnackbarFeedback;
